import axios from 'axios';

// Admin-only role change. The server re-checks both the admin flag and the value, so this is only
// the call, never what makes it allowed.
export const updateUserRole = async (userId, role, token) => {
  try {
    const { data } = await axios.put(
      `/api/users/admin/${userId}/role`,
      { role },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
